import { createSlice } from "@reduxjs/toolkit";
import { getLocalStorage,setLocalStorage} from "../../helpers/session";
 

export const collectionListSlice = createSlice({
	name: "collection_list",
	initialState: {
		collection: Array.isArray(getLocalStorage("collection", true)) ? getLocalStorage("collection", true) : [],
		errors: [],
	},

	reducers: {
		getCollection: (state, action) => {
			// console.log("Collection reducer", action.payload)
			// console.log("hello", {state});
			state.collection = [...state.collection, ...action.payload]
			 
		},
		getCollectionList: (state, action) => {
			state.collection = action.payload;
			 
			
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getCollection, getCollectionList, getErrors} = collectionListSlice.actions

export default collectionListSlice.reducer
